import { Box, Column, Divider, Row, Text } from '~/commonComponents';
import AcademicCapIcon from '~/images/academic-cap-icon.svg';
import OfficeBuildingIcon from '~/images/office-building-icon.svg';
import { TNullable } from '~/types/Nullable';
import { formatExperienceDates, formatGraduationDate } from '../../utils';

interface IResumePreviewProps {
  educations: IEducation[];
  experiences: IExperience[];
  professionalName: string;
  summaries: string;
}

interface IEducation {
  graduatesAt: TNullable<string>;
  institutionName: string;
}

interface IExperience {
  employerName: string;
  endsAt: TNullable<string>;
  isCurrentEmployer: boolean;
  startsAt: string;
  title: string;
}

export const ResumePreview = ({
  educations,
  experiences,
  professionalName,
  summaries,
}: IResumePreviewProps) => {
  return (
    <Box data-testid="candidate-resume">
      <Column gap={10} data-testid="about-section">
        <Text bold fontSize={20}>
          About {professionalName}:
        </Text>
        <Text>{summaries}</Text>
      </Column>

      <Divider height={2} marginVertical={22} width={'90%'} />

      <Column gap={14} data-testid="experience-section">
        <Text bold fontSize={20}>
          Professional Experience:
        </Text>
        <Column gap={22}>
          {experiences?.map((it, index) => (
            <Row key={`${it.employerName}-${index}`} gap={4} data-testid="experience-item">
              <img src={OfficeBuildingIcon} alt="office building icon" width={24} height={24} />
              <Column>
                <Text fontSize={18}>
                  <Text bold fontSize={18}>
                    {it.employerName}
                  </Text>{' '}
                  - {it.title}
                </Text>
                <Text italic color="neutral_500">
                  {formatExperienceDates(it.startsAt, it.endsAt, it.isCurrentEmployer)}
                </Text>
              </Column>
            </Row>
          ))}
        </Column>
      </Column>

      <Divider height={2} marginVertical={22} width={'90%'} />

      <Column gap={14} data-testid="education-section">
        <Text bold fontSize={20}>
          Highest Level of Education:
        </Text>
        {educations?.map((it, index) => (
          <Row key={`${it.institutionName}-${index}`} gap={4} data-testid="education-item">
            <img src={AcademicCapIcon} alt="academic cap icon" width={24} height={24} />
            <Column>
              <Text bold fontSize={18}>
                {it.institutionName}
              </Text>
              <Text italic color="neutral_500">
                Graduation Date: {formatGraduationDate(it.graduatesAt)}
              </Text>
            </Column>
          </Row>
        ))}
      </Column>
    </Box>
  );
};
